import {
  Wrapper,
  SkeletonBox,
  HeroCardSkeleton,
  HeroGridSkeleton,
  HeroLeftSkeleton,
  HeroRightSkeleton,
  MetricsGridSkeleton,
  MetricCellSkeleton,
  ActionsRowSkeleton,
  SectionCardSkeleton,
  SectionHeaderSkeleton,
  SectionTitleBlockSkeleton,
  ChartAreaSkeleton,
  RowsSkeleton,
  ListRowSkeleton,
} from "../styles";

const METRIC_CELLS = [0, 1, 2, 3, 4];
const CONTRIBUTION_ROWS = [0, 1, 2, 3];

// Mirrors the real hero + chart + list layout so the loading shape predicts the
// result and the page doesn't shift on load.
export const InvestmentSkeleton = () => (
  <Wrapper aria-busy="true" aria-label="Loading investment details">
    <HeroCardSkeleton>
      <HeroGridSkeleton>
        <HeroLeftSkeleton>
          <SkeletonBox width="60%" height="40px" />
          <SkeletonBox width="35%" height="18px" />
          <SkeletonBox width="50%" height="56px" />
          <SkeletonBox width="30%" height="24px" />
          <MetricsGridSkeleton>
            {METRIC_CELLS.map((cell) => (
              <MetricCellSkeleton key={cell}>
                <SkeletonBox width="70%" height="12px" />
                <SkeletonBox width="50%" height="18px" />
              </MetricCellSkeleton>
            ))}
          </MetricsGridSkeleton>
        </HeroLeftSkeleton>
        <HeroRightSkeleton>
          <ActionsRowSkeleton>
            <SkeletonBox width="48px" height="40px" />
            <SkeletonBox width="140px" height="40px" />
          </ActionsRowSkeleton>
          <SkeletonBox width="100%" height="180px" />
        </HeroRightSkeleton>
      </HeroGridSkeleton>
    </HeroCardSkeleton>

    <SectionCardSkeleton>
      <SectionHeaderSkeleton>
        <SectionTitleBlockSkeleton>
          <SkeletonBox width="180px" height="24px" />
          <SkeletonBox width="120px" height="16px" />
        </SectionTitleBlockSkeleton>
        <SkeletonBox width="220px" height="36px" />
      </SectionHeaderSkeleton>
      <ChartAreaSkeleton />
    </SectionCardSkeleton>

    <SectionCardSkeleton>
      <SectionHeaderSkeleton>
        <SectionTitleBlockSkeleton>
          <SkeletonBox width="160px" height="24px" />
          <SkeletonBox width="100px" height="16px" />
        </SectionTitleBlockSkeleton>
        <SkeletonBox width="120px" height="36px" />
      </SectionHeaderSkeleton>
      <RowsSkeleton>
        {CONTRIBUTION_ROWS.map((row) => (
          <ListRowSkeleton key={row}>
            <SkeletonBox width="48px" height="24px" />
            <SkeletonBox width="100%" height="16px" />
            <SkeletonBox width="80px" height="16px" />
          </ListRowSkeleton>
        ))}
      </RowsSkeleton>
    </SectionCardSkeleton>
  </Wrapper>
);
